import { FC, memo } from 'react'

import { DigitWrapper } from './styled'

const digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0]
const invertedDigits = digits.slice().reverse()

const Digit: FC<{
  value: number
  inverted: boolean
  invisibleZero?: boolean
}> = ({ value, inverted, invisibleZero }) => (
  <DigitWrapper
    inverted={inverted}
    value={value}
    invisible={invisibleZero && !value}
  >
    {(inverted ? invertedDigits : digits).map((v, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <span key={i}>{v}</span>
    ))}
  </DigitWrapper>
)

const EnhancedDigit = memo(Digit)

const DigitsBase: FC<{
  value: number
  places?: number
  inverted?: boolean
}> = ({ value, places = 2, inverted = false }) => {
  value = Math.max(0, value)
  const valueString = value?.toString()
  const paddedString = valueString.padStart(places, '0')

  return (
    <>
      {[...Array(paddedString.length - 1)].map((_, i) => (
        <EnhancedDigit
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          inverted={inverted}
          value={Number(paddedString[i])}
        />
      ))}
      <EnhancedDigit inverted={inverted} value={Math.max(0, value % 10)} />
    </>
  )
}

export const Digits = memo(DigitsBase)
